<template>
    <div>
        <eco-header :step_num="1" />
        <b-row>
            <b-col>
                <p>Введите корректные и действующие ИНН или ОГРНП/ОГРНИП вашей организации или ИП. 
                <br/>Форма загрузит все доступные данные из базы ИФНС. 
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-input-group>
                    <b-form-input placeholder="Введите нужное значение и нажмите клавишу Enter, например '0261027092'" v-model="inn" @keyup.enter="getInfo"></b-form-input>
                    <b-input-group-append>
                        <b-button v-if="spinner"><b-spinner small label="Loading..."></b-spinner></b-button>
                        <b-button @click="getInfo" variant="outline-primary" v-if="allowRequest">Искать</b-button>
                        <b-button @click="resetInfo" variant="outline-danger" v-if="info">Сброс</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row v-if="!info">
            <b-col>
                <br />
                <p>Если Вы желаете заполнить всю информацию вручную, просто нажмите кнопку "Далее".</p>
            </b-col>
        </b-row>
        <b-row v-if="info">
            <b-col>
                <eco-company-view :company="info" :items="items"/>
                <hr/>
            </b-col>
        </b-row>
        <b-row v-if="info">
            <b-col class="text-right">
                <b class="text-success">ДА</b><br/>
                Если это ваша организация или ИП, просто нажмите "Далее".
                Найденная информация быдет использована для автоматического заполнения формы. 
            </b-col>
            <b-col> 
                <b class="text-danger">НЕТ</b><br/>
                Если это НЕ ваша организация/ИП и вам не удается найти нужное, нажмите сначала "Сброс", затем "Далее".
                Очень жаль, но данные придется вводить вручную.
            </b-col>
        </b-row>
        <eco-footer :step_num="1" :allow_next="true"/>
    </div>
</template>

<script>
import axios from 'axios'


export default {
    data() {
        return {
            inn: '',
            info: null,
            spinner: false,
            items: [
                'opf.full', 'name.full', 
                'id.inn', 'id.kpp', 
                'ceo.name',
                'address.value'
            ]
        }
    },
    methods: {
        resetInfo() {
            this.info = null
        },
        getInfo() {
            this.info = null
            if(this.allowRequest) {
                this.spinner = true
                axios
                .get(window.$apiurl + '/info', {
                    params:{
                        req: this.inn
                    }
                })
                .then(res => {
                    if(res.data.status === 'ok') {
                        if(res.data.data.noactive != true) { 
                            this.info = res.data.data
                            this.$store.dispatch('COMPANY', this.info)
                        }
                    } else window.$showError(this, res.data) 
                    this.spinner = false
                })
                .catch(err => {
                    window.$showError(this, err) 
                })
            }
        }
    },
    computed:{
        allowRequest() {
            if(this.inn.length >= 10) {
                return true
            } return false
        }
    }
}
</script>